import React from 'react';
import {Stack, Typography} from '@mui/material';
import WhiteboardRow from './WhiteboardRow';

/**
 * Displays a table of whiteboards with headers and rows
 * @param {Object} props
 * @param {Array} props.whiteboards - Array of whiteboard data
 * @param {Array} props.columns - Column configuration
 * @param {boolean} props.loading - Loading state
 * @param {string|null} props.cloningId - ID of the whiteboard currently being cloned
 * @param {Function} props.onTitleClick - Title click handler
 * @param {Function} props.onClone - Clone handler
 * @param {Function} props.onDeleted - Called after a row is deleted
 * @returns {JSX.Element}
 */
const WhiteboardsTable = ({whiteboards, columns, loading, cloningId, onTitleClick, onTitleHover, onClone, onDeleted}) => {
    const renderContent = () => {
        if (loading) {
            return (
                <Stack bgcolor="white" px={2} py={2}>
                    <Typography>Loading charts...</Typography>
                </Stack>
            );
        }

        if (!whiteboards || whiteboards.length === 0) {
            return (
                <Stack bgcolor="white" px={2} py={2}>
                    <Typography>No charts yet. Click "Create New Chart" to create one.</Typography>
                </Stack>
            );
        }

        return whiteboards.map((whiteboard, index) => (
            <WhiteboardRow
                key={whiteboard.id || index}
                whiteboard={whiteboard}
                columns={columns}
                isCloning={cloningId === whiteboard.id}
                onTitleClick={onTitleClick}
                onTitleHover={onTitleHover}
                onClone={onClone}
                onDeleted={onDeleted}
            />
        ));
    };

    return (
        <Stack
            borderRadius={1}
            border="1px solid #e0e0e0"
            bgcolor="#e0e0e0"
            spacing="1px"
            overflow={'hidden'}
        >
            <Stack
                direction="row"
                spacing={2}
                px={2}
                py={1}
                bgcolor="#e9ecef"
                overflow="hidden"
                alignItems="center"
            >
                {columns.map((column) => (
                    <Typography key={column.field} flex={column.flex} fontWeight="bold">
                        {column.headerName}
                    </Typography>
                ))}
                <Stack sx={{width: 40, minWidth: 40, flexShrink: 0}} />
            </Stack>

            {renderContent()}
        </Stack>
    );
};

export default WhiteboardsTable;
